// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__26Ri5","footer":"ModalUpdate_footer___jVpj"};